/**
 * Wather for header city
 * @param {function} handler handler when city has changed call with new city id
 * @returns {object} mutation observer
 */

const useHeaderCityObserver = handler => {
  const headerCity = document.getElementById('select-city-container')

  if (!headerCity) return null

  const config = {
    attributes: true,
    childList: true,
    subtree: true,
  }

  const cb = mutations => {
    const mutation = mutations[0]

    if (mutation.attributeName !== 'data-city-id') return

    const newCityId = mutation.target.dataset.cityId

    handler(newCityId)
  }

  const observer = new MutationObserver(cb)

  observer.observe(headerCity, config)

  return observer
}

export default useHeaderCityObserver
